import { useState } from "react";
import { Button } from "@/design-system/components/ui";
import { portalAuthApi } from "../api/auth";
import { usePortalAuth } from "../PortalAuthContext";

// UAT FixBatch FIND-17 — one-time "You're certified" welcome. Renders only
// while /me flags showCertificationWelcome; dismissing acknowledges it
// server-side (POST /broker/welcome-acknowledged) and refetches /me so it
// won't show again on the next render or session.
export function CertificationWelcomeModal() {
  const auth = usePortalAuth();
  const [busy, setBusy] = useState(false);

  if (!auth.me?.showCertificationWelcome) return null;

  async function dismiss() {
    setBusy(true);
    try {
      await portalAuthApi.acknowledgeWelcome();
      await auth.refresh();
    } finally {
      setBusy(false);
    }
  }

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-onyx/50 p-space-4"
      data-testid="certification-welcome"
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-label="You're certified"
        className="max-w-lg w-full rounded-md bg-white-pure p-space-6 shadow-lg border-t-[2px] border-t-gold text-center"
      >
        <h2 className="font-display font-bold text-h2 text-onyx m-0 uppercase tracking-label">
          You're certified!
        </h2>
        <p className="text-body text-gray-mid mt-space-3 max-w-reading mx-auto">
          Welcome to the Phoenix Capital broker team. You can now submit deals
          and access the materials library.
        </p>
        <div className="mt-space-5 flex justify-center">
          <Button
            type="button"
            onClick={() => void dismiss()}
            disabled={busy}
            data-testid="certification-welcome-cta"
          >
            {busy ? "…" : "Continue to portal"}
          </Button>
        </div>
      </div>
    </div>
  );
}
